import { computed, reactive } from '@vue/composition-api';
import { api } from '../api';
import AuthButton from './AuthButton.vue';
import AuthCallback from './AuthCallback.vue';
import { AuthFlow } from './openid';

export default {
    install(Vue, options) {
        Vue.component('AuthButton', AuthButton);
        Vue.component('AuthCallback', AuthCallback);

        const authFlow = new AuthFlow({
            authUrl: options.authUrl,
            clientId: options.clientId,
            redirectUri: `${window.location.origin}/${options.redirectPath}`,
        });

        const state = reactive({
            token: null,
        });

        const isLogged = computed(() => !!state.token);

        const store = {
            state,
            isLogged,
            startLogin(prompt = undefined) {
                return authFlow.start(prompt);
            },
            parseState(state) {
                return authFlow.parseState(state);
            },
            async exchangeCode(code) {
                state.token = await authFlow.getToken(code);
                if (typeof options.onToken === 'function') {
                    await options.onToken(state.token);
                }
                return state.token;
            },
            async logout() {
                await authFlow.revokeTokens(state.token);
                state.token = null;
                if (typeof options.onLogout === 'function') {
                    await options.onLogout();
                } 
                authFlow.logout();
            },
            async silentLogin() {
                state.token = await authFlow.silentLogin();
                if (typeof options.onToken === 'function') {
                    await options.onToken(state.token);
                }
                return state.token;
            },
            async refreshToken() {
                if (state.token.refreshToken) {
                    state.token = await authFlow.useRefreshToken(api.token.refreshToken);
                    if (typeof options.onToken === 'function') {
                        await options.onToken(state.token);
                    }
                }
            }
        };

        api.http.interceptors.request.use(async config => {
            if (api.token) {
                const payload = authFlow.getPayload(api.token.accessToken);
                if (Math.floor(Date.now() / 1000) > payload.exp - 10) {
                    try {
                        // await store.silentLogin();
                        await store.refreshToken();
                    } catch (err) {
                        // Silent error
                    }
                }

            }
            return config;
        });

        Vue.prototype.$auth = store;
    },
};